import React from 'react';
import DownloadButton from '../common/DownloadButton/DownloadButton'
import {styleContainer, styleContainerTitle, styleTitle, styleButton} from './extendedwarranty.style'


export const CustomExtendedWarranty = (props) => (
    <div style={{flex: '1 1 0%', padding: '2em'}}>
        <div style={styleContainer}>
                <div style={styleContainerTitle}>
                    <span style={styleTitle}>
                    Garantía extendida</span>
                </div>
            <div style={styleButton}>
                <DownloadButton resource = 'extendedwarranty'/>
            </div>
        </div>
    </div>
);